var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteGreyRectangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1440,
    height: 97,
    fill: "none",
    viewBox: "0 0 1440 97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F6",
    d: "M-1.39.31L1440.7 96.032H-1.39V.31z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteGreyRectangle);
export default __webpack_public_path__ + "static/media/WhiteGreyRectangle.f0a157008ebd11b1140a4d7a55f392e1.svg";
export { ForwardRef as ReactComponent };